import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon, _Glyphicon2, _p;
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { deprecate } from 'react-is-deprecated';
import { Col, Glyphicon, Label, List, Row, Section, Text } from 'reaxl';

/**
 *  Formats Next Steps CTAs section in email confirmation modal
 */
function EmailFormNextSteps(_ref) {
  let {
    callsToAction = [],
    timeSavingCTAs = [],
    // deprecated
    uiContext = 'default'
  } = _ref;
  // Handle deprecated prop
  if (!callsToAction.length && timeSavingCTAs.length) {
    callsToAction = timeSavingCTAs;
  }
  if (!callsToAction.length) return null;
  const renderItem = function (_temp) {
    let {
      secondaryText,
      labelText,
      render
    } = _temp === void 0 ? {} : _temp;
    switch (uiContext) {
      case 'two-column':
        return /*#__PURE__*/_jsx(Row, {
          className: "display-flex align-items-center"
        }, void 0, /*#__PURE__*/_jsx(Col, {
          xs: 6
        }, void 0, render), /*#__PURE__*/_jsx(Col, {
          xs: 6,
          className: "text-left"
        }, void 0, /*#__PURE__*/_jsx(Text, {
          color: "subdued-lightest",
          componentClass: "div",
          size: 200
        }, void 0, secondaryText), labelText && /*#__PURE__*/_jsx(Label, {
          bsStyle: "info-inverse",
          className: "display-inline-flex gap-1 align-items-baseline"
        }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
          glyph: "clock",
          "aria-hidden": "true"
        })), labelText)));
      case 'button':
        return render;
      case 'default':
      default:
        return /*#__PURE__*/_jsx(Row, {
          className: "display-flex align-items-center"
        }, void 0, /*#__PURE__*/_jsx(Col, {
          xs: 6
        }, void 0, render, /*#__PURE__*/_jsx(Text, {
          color: "subdued-lightest",
          componentClass: "div",
          size: 200
        }, void 0, secondaryText)), labelText && /*#__PURE__*/_jsx(Col, {
          xs: 6,
          className: "text-right"
        }, void 0, /*#__PURE__*/_jsx(Label, {
          bsStyle: "info-inverse",
          className: "display-inline-flex gap-1 align-items-baseline"
        }, void 0, _Glyphicon2 || (_Glyphicon2 = /*#__PURE__*/_jsx(Glyphicon, {
          glyph: "clock",
          "aria-hidden": "true"
        })), labelText)));
    }
  };
  return /*#__PURE__*/_jsx(Section, {
    alignment: "left",
    subheading: "Reduce wait time at the dealership",
    uiContext: "section-4"
  }, void 0, _p || (_p = /*#__PURE__*/_jsx("p", {}, void 0, "By completing these steps now, you could save more time during your visit.")), /*#__PURE__*/_jsx(List, {
    className: "list-unstyled margin-vertical-2",
    expanded: true,
    items: callsToAction,
    render: renderItem
  }));
}
export default /*#__PURE__*/memo(EmailFormNextSteps);